import $ from 'jquery';

// $('.liczby__number').each(function(){
//     let this_nr = $(this).text();
//     console.log(this_nr);
//     $(this).text(0);

// });
$.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();
  
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
  
    return elementBottom > viewportTop && elementTop < viewportBottom;
  };
  
if ($('.liczby__row')[0]){

  $(window).on('resize scroll', function(e) {
    
    if ($('.liczby__row').isInViewport()) {
      $('.liczby__number.active').each(function () {
        $('.liczby__number').removeClass('active');
        var $this = $(this);
        let this_nr = $(this).text();
        
        $({ Counter: 0 }).animate({ Counter: this_nr }, {
          duration: 4000,
          easing: 'swing',
          step: function () {
            $this.text(Math.ceil(this.Counter));
          }
        });
      }); 
      e.stopPropagation();
    } 
  });
}